import { initSentry } from "./sentry";
import { initErrorReporting, reportApiError } from "./error-reporting";
import { initRouteTracking, initRequestTracing, initPerformanceTracking, initUserActionTracking } from "./tracking";
import { initReleaseTracking } from "./release";
import { startSpan } from "./sentry";

export function initObservability(): void {
  if (typeof window === "undefined") return;

  initSentry();
  initErrorReporting();
  initRouteTracking();
  initRequestTracing();
  initPerformanceTracking();
  initUserActionTracking();
  initReleaseTracking();
}

export function startRequestTrace(name: string): { end: () => void } {
  const span = startSpan(name, "http.request");
  return {
    end: () => {
      span.end();
    },
  };
}

export function traceApiCall<T>(url: string, method: string, fn: () => Promise<T>): Promise<T> {
  const trace = startRequestTrace(`${method} ${url}`);
  return fn()
    .then((result) => {
      trace.end();
      return result;
    })
    .catch((error) => {
      trace.end();
      reportApiError(error, url, method);
      throw error;
    });
}

export function traceComponentRender<T>(componentName: string, fn: () => T): T {
  const startTime = performance.now();
  const result = fn();
  const duration = Math.round(performance.now() - startTime);
  const span = startSpan(componentName, "component.render");
  span.setAttribute("component", componentName);
  span.end();
  return result;
}

export function withTrace<T>(name: string, op: string, fn: () => Promise<T>): Promise<T> {
  const span = startSpan(name, op);
  return fn()
    .then((result) => {
      span.end();
      return result;
    })
    .catch((error) => {
      span.setAttribute("error", "true");
      span.end();
      throw error;
    });
}